import {createStore} from 'vuex'
import Notification from "@/classes/component-classes/Notification";
import ValidatedField from "@/classes/global/ValidatedField";
import GridColumn from "@/classes/component-classes/GridColumn";

export default createStore({
    state: {

        loginDetails: {},

        userSettings: {
            searchShipmentColumns: {air: [], sea: [], road: [], rail: [], courier: [], other: []}
        },

        metaData: {

            countries: [],
            packagingTypes: [],
            currencies: [],
            terms: []
        },

        contactTitleSelection: [

            {
                id: '1',
                value: 'Mr'
            },
            {
                id: '2',
                value: 'Mrs'
            },
            {
                id: '3',
                value: 'Miss'
            },
            {
                id: '4',
                value: 'Ms'
            },
            {
                id: '5',
                value: 'Mx'
            },

        ],

        globalHelpIcon: 'fa fa-info-circle icon-info',

        emailRegExCheck: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,


        arrivingToday: [

            {
                id: 1000402,
                customerRef: 'Customer Ref',
                jobNumber: 'HG65534',
                jobType: 'Export',
                date: '11-Mar-24',
                mode: 'rail'
            },
            {
                id: 2,
                customerRef: 'Another Ref',
                jobNumber: 'HD11534',
                jobType: 'Import',
                date: '11-Mar-24',
                mode: 'air'
            },
            {
                id: 1,
                customerRef: 'Customer Ref',
                jobNumber: 'HG65534',
                jobType: 'Export',
                date: '11-Mar-24',
                mode: 'road'
            },
            {
                id: 2,
                customerRef: 'Another Ref',
                jobNumber: 'HD11534',
                jobType: 'Import',
                date: '11-Mar-24',
                mode: 'rail'
            },
            {
                id: 1,
                customerRef: 'Fairly Long customer reference',
                jobNumber: 'HG65534',
                jobType: 'Export',
                date: '11-Mar-24',
                mode: 'sea'
            },
            {
                id: 2,
                customerRef: 'Another Ref',
                jobNumber: 'HD11HHHe33a22212534',
                jobType: 'Import',
                date: '11-Mar-24',
                mode: 'air'
            },
            {
                id: 1,
                customerRef: 'Customer Ref',
                jobNumber: 'HG65534',
                jobType: 'Export',
                date: '11-Mar-24',
                mode: 'road'
            },
            {
                id: 2,
                customerRef: 'Another Ref',
                jobNumber: 'HD11534',
                jobType: 'Import',
                date: '11-Mar-24',
                mode: 'rail'
            },
            {
                id: 2,
                customerRef: 'Another Ref',
                jobNumber: 'HD11534',
                jobType: 'Import',
                date: '11-Mar-24',
                mode: 'air'
            },
            {
                id: 1,
                customerRef: 'Customer Ref',
                jobNumber: 'HG65534',
                jobType: 'Export',
                date: '11-Mar-24',
                mode: 'road'
            },
            {
                id: 2,
                customerRef: 'Another Ref',
                jobNumber: 'HD11534',
                jobType: 'Import',
                date: '11-Mar-24',
                mode: 'rail'
            },
            {
                id: 1,
                customerRef: 'Customer RewwwwwwwwwwwwwuuUUUUUUUUUUUUUUUUUUUUUUUUUUUf',
                jobNumber: 'HG65534',
                jobType: 'Export',
                date: '11-Mar-24',
                mode: 'sea'
            },
            {
                id: 2,
                customerRef: 'Another Ref',
                jobNumber: 'HD11HHHe33a22212534',
                jobType: 'Import',
                date: '11-Mar-24',
                mode: 'air'
            },
            {
                id: 1,
                customerRef: 'Customer Ref',
                jobNumber: 'HG65534',
                jobType: 'Export',
                date: '11-Mar-24',
                mode: 'road'
            },
            {
                id: 2,
                customerRef: 'Another Ref',
                jobNumber: 'HD11534',
                jobType: 'Import',
                date: '11-Mar-24',
                mode: 'rail'
            },


        ],


        tempSecurityId: '205ed095-0eb8-4f92-b428-671ca9c74564',

        // TRIGGERS FOR GLOBAL BANNERS AND LOADERS
        banners: {
            error: new Notification(),
            success: new Notification(),
            warning: new Notification(),
        },

        hideLoadingSpinner: true,
        showNewGridFeature: true,

        newGridPaginationRange: 1,
        newGridCurrentPage: 1,

        caughtURL: '',

        // ToDo make class to new up in view's
        widgetList: [

            // {
            //     id: '2',
            //     name: 'import-origins',
            //     start: false,
            //     over: false,
            //     end: false,
            // }
            {
                id: '3',
                name: 'completed-shipments',
                start: false,
                over: false,
                end: false,
            },
            {
                id: '1',
                name: 'arrivals',
                start: false,
                over: false,
                end: false,
            },


            {
                id: '4',
                name: 'arriving-today',
                start: false,
                over: false,
                end: false,
            },
            {
                id: '5',
                name: 'late-arrivals',
                start: false,
                over: false,
                end: false,
            },
            {
                id: '6',
                name: 'month-ahead',
                start: false,
                over: false,
                end: false,
            },

            {
                id: '7',
                name: 'delivered-today',
                start: false,
                over: false,
                end: false,
            },
            {
                id: '8',
                name: 'late-deliveries',
                start: false,
                over: false,
                end: false,
            },


        ],

        dataSource: [
            {
                id: '1',
                value: 'Option_1'
            },
            {
                id: '2',
                value: 'Option_2'
            },
            {
                id: '3',
                value: 'Option_3'
            },
            {
                id: '4',
                value: 'Option_4'
            },
            {
                id: '5',
                value: 'Option_5'
            },
            {
                id: '6',
                value: 'Option_6'
            },
            {
                id: '7',
                value: 'Option_7'
            },
            {
                id: '8',
                value: 'Option_8'
            },
            {
                id: '9',
                value: 'Option_9'
            },
            {
                id: '10',
                value: 'Option_10'
            },
            {
                id: '11',
                value: 'Option_11'
            },
            {
                id: '12',
                value: 'Option_12'
            },
            {
                id: '13',
                value: 'Option_13'
            },
            {
                id: '14',
                value: 'Option_14'
            },
            {
                id: '15',
                value: 'Option_15'
            },
            {
                id: '16',
                value: 'Option_16'
            },
            {
                id: '17',
                value: 'Option_17'
            },
            {
                id: '18',
                value: 'Option_18'
            },
            {
                id: '19',
                value: 'Option_19'
            },
            {
                id: '20',
                value: 'Option_20'
            }

        ],

        showDrawer: false,

        // ToDo remove the menu object from store into the menu component if not needed here

        // mainMenu: {},

        mainMenu: {

            dashboard: {
                menuId: '1',
                active: false,
                alias: 'Dashboard'
            },

            orders: {
                menuId: '2',
                active: false,
                alias: 'Orders'
            },

            bookings: {
                menuId: '3',
                active: false,
                alias: 'Bookings',
            },

            freightBooking: {
                menuId: '4',
                active: true,
                alias: '',
            },

            agentBooking: {
                menuId: '5',
                active: true,
                alias: '',
            },

            warehouse: {
                menuId: '6',
                active: false,
                alias: 'Stock'
            },

            shipments: {
                menuId: '7',
                active: true,
                alias: 'Shipments'
            },

            quotes: {
                menuId: '8',
                active: false,
                alias: 'Quotes'
            },

            purchaseOrders: {
                menuId: '9',
                active: false,
                alias: 'Purchase Orders'
            },

            reports: {
                menuId: '10',
                active: false,
                alias: 'Reports'
            },

            documents: {
                menuId: '11',
                active: false,
                alias: 'Documents'
            },

            shipmentItems: [
                {
                    menuId: '12',
                    alias: 'Show Shipments',
                    view: 'showshipments',
                    active: true,

                },
                {
                    menuId: '13',
                    alias: "Update POD's",
                    view: 'updatepods',
                    active: false,

                }
            ],

            warehouseItems: [
                {
                    menuId: '14',
                    alias: 'Check Stock',
                    view: 'stock',
                    id: 'new',
                    active: false,
                },
                {
                    menuId: '15',
                    alias: 'PickStock',
                    view: 'pickstock',
                    id: 'new',
                    active: false
                },
                {
                    menuId: '16',
                    alias: 'Browse Picks',
                    view: 'browsepick',
                    id: 'new',
                    active: false
                },
                {
                    menuId: '17',
                    alias: 'SKU History',
                    view: 'skuhistory',
                    id: 'new',
                    active: false
                }
            ],

            freightItems: [

                {
                    menuId: '18',
                    alias: 'Freight Booking',
                    section: 'freightBooking',
                    view: 'booking',
                    id: 'new',
                    active: false
                },
                {
                    menuId: '19',
                    alias: 'Courier Booking',
                    section: 'courierBooking',
                    view: 'booking',
                    id: 'new',
                    active: false
                },

            ],

            agentItems: [
                {
                    menuId: '20',
                    alias: 'Air Booking',
                    section: 'Air',
                    view: 'prejob',
                    id: 'new',
                    active: false
                },
                {
                    menuId: '21',
                    alias: 'Sea Booking',
                    section: 'Sea',
                    view: 'prejob',
                    id: 'new',
                    active: false
                },
                {
                    menuId: '22',
                    alias: 'Road Booking',
                    section: 'Road',
                    view: 'prejob',
                    id: 'new',
                    active: false
                },
                {
                    menuId: '23',
                    alias: 'Rail Booking',
                    section: 'Rail',
                    view: 'prejob',
                    id: 'new',
                    active: false
                },

            ],

            orderItems: [
                {
                    menuId: '24',
                    alias: 'New PO',
                    view: 'purchaseorder',
                    id: 'new',
                    active: false
                },
                {
                    menuId: '25',
                    alias: 'Browse',
                    view: 'purchaseorder',
                    id: 'browse',
                    active: false
                },


            ],

            quoteItems: [
                {
                    menuId: '26',
                    alias: 'Create Quote',
                    view: 'quote',
                    id: 'new',
                    active: false
                },
                {
                    menuId: '27',
                    alias: 'Browse Quote',
                    view: 'browsequote',
                    id: 'browse',
                    active: false
                },
            ]

        },

        dummyGridColumns: [

            new GridColumn('1', 'SKU Number', 'skuGroup', '120', true, false, 'rowColor'),
            new GridColumn('2', 'SKU Composite', 'skuNumber', '120', true, false, 'rowColor'),
            new GridColumn('3', 'Warehouse', 'skuName', '120', true, false),
            new GridColumn('4', 'Location', 'jobRef', '100', true, false),
            new GridColumn('5', 'WH Ref', 'warehouseRef', '120', true, false),
            new GridColumn('6', 'Job No.', 'customerRef', '100', true, false),
            new GridColumn('7', 'Date', 'soNumber', '50', true, false),
            new GridColumn('8', 'Location Stock', 'deliverTo', '130', true, false),
            new GridColumn('9', 'Total Stock', 'dateFrom', '70', true, false),
            new GridColumn('10', 'Cust Ref', 'dateTo', '70', true, false),
            new GridColumn('9', 'Curr', 'dateFrom', '70', false, false),
            new GridColumn('10', 'Value', 'dateTo', '70', false, false),
            // new GridColumn('11', '', 'selectedRow', '60', true, false),

        ],

        browseWarehouseTempCols: [
            new GridColumn('1', 'View', 'view', '40', true, true, '', 'rowColor'),
            new GridColumn('2', 'Complete', 'complete', '80', true, false, '', 'rowColor'),
            new GridColumn('3', 'WarehouseRef', 'warehouseRef', '265', true, false),
            new GridColumn('4', 'Release Date', 'releaseDate', '180', true, false),
            new GridColumn('5', 'Release By', 'releaseBy', '140', true, false),
            new GridColumn('6', 'Deliver To', 'deliverTo', '180', true, false),
            new GridColumn('10', 'Delivery Date', 'deliveryDate', '70', true, false),
            new GridColumn('7', 'Release / Delivery Instructions', 'delInstructions', '200', true, false),
            new GridColumn('8', 'CustomerRef', 'customerRef', '180', true, false),
            new GridColumn('9', 'Notification', 'notification', '70', true, false),

        ],

        // dummyGridData: [],
        dummyGridData: [

            {
                id: '1',
                skuNumber: 'Sports Jacket',
                warehouse: 'London',
                location: 'BR778998',
                warehouseRef: 'WHOIYFHJ875',
                jobNumber: 'HI7564337',
                quantity: '456',
                dateTime: '17-Apr-23 13:34',
                locationStock: '785',
                totalStock: '1356',
                customerRef: 'BCUS7654689909987',
                groupLate: '#ffe5e5',
            },


        ],

        dummyPickStockGridColumns: [

            new GridColumn('1', 'SKU Group', 'skuGroup', '200', true, false, 50, 'noStock'),
            new GridColumn('2', 'SKU Number', 'skuNumber', '200', true, true, 50, 'noStock'),
            new GridColumn('3', 'SKU Name', 'skuName', '200', true, true, 50, 'noStock'),
            new GridColumn('4', 'Total', 'total', '50', true, false, 40, 'noStock'),
            new GridColumn('5', 'Warehouse', 'warehouse', '200', true, true, 50, 'noStock'),
            new GridColumn('7', 'Available', 'available', '180', true, true, 50, 'noStock'),
            new GridColumn('6', 'Description Headers', 'skuProperties', '110', true, true, 50),
            new GridColumn('8', 'QTY', 'pickQuantity', '60', true, true, 10, 'noStock'),
            new GridColumn('9', '', 'pick', '75', true, false, 40, 'noStock'),
            new GridColumn('10', 'Allocated', 'allocated', '60', true, true, 10),
            new GridColumn('10', 'Comments', 'comments', '310', true, true, 10),

        ],

        dummyPickStockGridData: [

            {
                id: '1',
                skuGroup: 'Clothing',
                skuNumber: 'MO8763346L',
                skuName: 'Sports Jacket',
                jobRef: 'Job Reference',
                warehouse: 'WH8754388HHH',
                total: '253',
                available: '100',
                pickQuantity: null,
                comments: '',
                allocated: '',
                zeroStock: true,

                skuProperties: {

                    descHeadOne: {
                        heading: 'Color',
                        value: 'Blue'
                    },

                    descHeadTwo: {
                        heading: 'Size',
                        value: 'Large'
                    },

                    descHeadThree: {
                        heading: 'Material',
                        value: 'Latex Fabiozoo'
                    },

                    descHeadFour: {
                        heading: 'Collar Type',
                        value: 'Modern'
                    },

                    descHeadFive: {
                        heading: 'Cuff Style',
                        value: 'Loose Button'
                    },

                    descHeadSix: {
                        heading: 'Fit Style',
                        value: 'Fitted'
                    },

                    skuDescription: 'General context jacket sold for winter season',
                }

            },
            {
                id: '2',
                skuGroup: 'Bikes',
                skuNumber: 'PPP9864DS',
                skuName: 'Sports Jacket',
                jobRef: 'Job Reference',
                warehouse: 'WH8754388HHH',
                available: '1',
                pickQuantity: null,
                comments: '',
                zeroStock: false,
                skuProperties: {

                    descHeadOne: {
                        heading: 'Color',
                        value: 'Red'
                    },

                    descHeadTwo: {
                        heading: 'Size',
                        value: ''
                    },

                    descHeadThree: {
                        heading: 'Material',
                        value: ''
                    },

                    descHeadFour: {
                        heading: 'Collar Type',
                        value: ''
                    },

                    descHeadFive: {
                        heading: 'Cuff Style',
                        value: 'Elastic'
                    },

                    descHeadSix: {
                        heading: 'Fit Style',
                        value: 'Sllack'
                    },

                    skuDescription: 'General context jacket sold for summer season range',
                }

            },
            {
                id: '3',
                skuGroup: 'Shoes',
                skuNumber: 'MO8763346L',
                skuName: 'Sports Jacket',
                jobRef: 'Job Reference',
                warehouse: 'WH8754388HHH',
                available: '55',
                pickQuantity: null,
                comments: '',
                skuProperties: {

                    descOne: {
                        heading: 'Color',
                        value: 'Blue'
                    },

                    descTwo: {
                        heading: 'Size',
                        value: 'Large'
                    },

                    descThree: {
                        heading: 'Material',
                        value: 'Latex Fabiozoo'
                    },

                    descFour: {
                        heading: 'Collar Type',
                        value: 'Modern'
                    },

                    descFive: {
                        heading: 'Cuff Style',
                        value: 'Loose Button'
                    },

                    descSix: {
                        heading: 'Fit Style',
                        value: 'Fitted'
                    },

                    skuDescription: 'General context jacket sold for winter season',
                }

            },
            {
                id: '4',
                skuGroup: 'Clothing',
                skuNumber: 'MO8763346L',
                skuName: 'Sports Jacket',
                jobRef: 'Job Reference',
                warehouse: 'WH8754388HHH',
                available: '12',
                pickQuantity: null,
                comments: '',
                skuProperties: {

                    descOne: {
                        heading: 'Color',
                        value: 'Blue'
                    },

                    descTwo: {
                        heading: 'Size',
                        value: 'Large'
                    },

                    descThree: {
                        heading: 'Material',
                        value: 'Latex Fabiozoo'
                    },

                    descFour: {
                        heading: 'Collar Type',
                        value: 'Modern'
                    },

                    descFive: {
                        heading: 'Cuff Style',
                        value: 'Loose Button'
                    },

                    descSix: {
                        heading: 'Fit Style',
                        value: 'Fitted'
                    },

                    skuDescription: 'General context jacket sold for winter season',
                }

            },


        ]

    },


})
